import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const WorkShiftDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Work Shift"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Work Shift">
                {getFieldDecorator('workShift', {
                 initialValue: data.workShift,
                  rules: [{ required: true, message: 'Please input the Work Shift!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default WorkShiftDialogForm;
